import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/index';

class PrivateAdminRoute extends Component {
  state = {
    isAdminReady: false
  };

  componentDidMount() {
    const { actions, isadmin, isspecialist } = this.props;
    if(isadmin === undefined || isspecialist === undefined) {
      actions.isadmin();
    }
  }

  componentWillReceiveProps(prevProps) {
    const { isadmin, isspecialist} = this.props;
    if ((isadmin !== prevProps.isadmin) || (isspecialist !== prevProps.isspecialist)) {
      this.setState({ isAdminReady: true });
    }
  }
  
  renderRoute = (routeProps) => {
    const { isAdminReady } = this.state;
    const { component: Component, isadmin, isadminLoading, isspecialist, isSuperAlumniAdmin, isCouncilCommittee, isCSTSupport, isAlumniAdmin, location } = this.props;
    const currentPath = location.pathname.toLowerCase();
    
    console.log("isAdmin", isadmin)
    console.log("isSpecialist:", isspecialist);
    console.log("Path:", this.props.location.pathname);
    console.log("isSuperAlumniAdmin:", isSuperAlumniAdmin);
    
    const restrictedPages = ['/pending-membership', '/record-repair', '/bulk-upload', '/manage-roles', '/Promo-Code-Portal', '/Add-Promo-Code-Portal'];
    const superAdminRestricted = [ '/quick-search', '/advanced-search'];

    if (isadmin === undefined && isspecialist === undefined && isSuperAlumniAdmin === undefined) {
      return <Redirect to={{ pathname: '/loading', state: { from: this.props.location } }}  />
    } 

    if (restrictedPages.includes(currentPath) && !isSuperAlumniAdmin) {
      return <Redirect to={{ pathname: '/unauthorized', state: { from: location } }} />;
    }

    if (superAdminRestricted.includes(currentPath) && (isSuperAlumniAdmin || isCouncilCommittee || isCSTSupport || isAlumniAdmin)) {
      return <Redirect to={{ pathname: '/unauthorized', state: { from: location } }} />;
    }

    if (!isadmin && !isspecialist && !isadminLoading) {
      return <Redirect to={{ pathname: '/unauthorized', state: { from: location } }} />;
    }

    return <Component {...routeProps} />
  };

  render() {
    const {component: Component, isadmin, isadminLoading, isspecialist, isSuperAlumniAdmin, isCouncilCommittee, isCSTSupport, isAlumniAdmin, location, ...rest} = this.props;
    
    return (
      <Route
        {...rest}
        render={(routeProps) =>
          this.renderRoute(routeProps)
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isadminLoading: state.isadminreducer.loading,
  isadmin: state.isadminreducer.isadmin,
  isspecialist: state.isadminreducer.isspecialist,
  isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
  isCouncilCommittee: state.isadminreducer.isCouncilCommittee,
  isCSTSupport: state.isadminreducer.isCSTSupport,
  isAlumniAdmin: state.isadminreducer.isAlumniAdmin,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateAdminRoute));


// WEBPACK FOOTER //
// ./src/components/HOC/PrivateAdminRoute.js